import { FunctionComponent } from 'react'
import { Route } from 'react-router-dom'
import { default as MainLayout } from 'components/Layout'
import mockChats from 'data/mockChats.json'
import links from 'views/fullLinks'
import { makeStyles, Typography } from '@material-ui/core'
import DNav from 'components/DNav/DNav'
import Chat from 'components/Chat/Chat'
import { useUser } from 'context/UserContext'
import logger from 'utils/logger'

interface ILayoutRouteProps {
    component: any
    layout?: any
    path: string
    [index: string]: any
}

const useStyles = makeStyles((theme) => ({
    root: {},
    chatHeading: {
        margin: theme.spacing(0, 1),
    },
}))

const LayoutRoute: FunctionComponent<ILayoutRouteProps> = (
    props: ILayoutRouteProps
) => {
    const { loading, user } = useUser() // Authed user if available
    const { layout: Layout = MainLayout, component: Component, ...rest } = props
    const { chats } = {
        chats: mockChats,
    }
    const loadingChats = false
    const handleChatRequest = () => {
        /* no-op for now */
    }
    const classes = useStyles()
    logger().debug('Initial user info from LayoutRoute:', user, loading)
    return (
        <Route
            {...rest}
            render={(matchProps) => (
                <Layout
                    profile={user}
                    navContent={<DNav links={links} />}
                    asideContent={
                        <>
                            <header className={classes.chatHeading}>
                                <Typography variant="h3" color="secondary">
                                    Chat
                                </Typography>
                            </header>
                            <Chat
                                chats={chats}
                                untrustedChatSender={
                                    (!loading && user?.userId) || undefined
                                }
                                noReframe={true}
                                handleChatRequest={handleChatRequest}
                                formProps={{}}
                                loading={loadingChats}
                            />
                        </>
                    }
                >
                    <Component {...matchProps} />
                </Layout>
            )}
        />
    )
}

export default LayoutRoute
